import { useSelector } from 'react-redux'
import styles from '../InternalExternalDetail.module.css'
import SectionHeader from './SectionHeader'
import EduCard from './EduCard'

const parseEducationStr = (item) => {
  if (item && typeof item === 'object') {
    const degree = [item.degree, item.field_of_study].filter(Boolean).join(', ') || item.title || ''
    const institution = item.school || item.school_name || item.institution || ''
    const year = item.end_date_year || item.end_date?.year || item.graduation_year || ''
    return { iconType: 'roundBadge', title: degree, meta: institution, year: year ? String(year) : '' }
  }
  const s = String(item || '')
  const atIdx = s.indexOf(' at ')
  const degree = atIdx > -1 ? s.substring(0, atIdx).trim() : s.trim()
  const rest = atIdx > -1 ? s.substring(atIdx + 4) : ''
  const inIdx = rest.lastIndexOf(' in ')
  const institution = inIdx > -1 ? rest.substring(0, inIdx).trim() : rest.trim()
  const period = inIdx > -1 ? rest.substring(inIdx + 4).trim() : ''
  return { iconType: 'roundBadge', title: degree, meta: institution, year: period }
}

const mapEducationRecord = (record) => ({
  iconType: 'roundBadge',
  title: record.Courses?.CourseName || record.CourseTypes?.CourseTypeName || '—',
  meta: record.Schools?.SchoolName || '—',
  year: record.YearCompleted ? String(record.YearCompleted) : '—',
})

const EducationSectional = ({ mode }) => {
  const rawData = useSelector((state) => state.externalUserDetailReducer.rawData)
  const userSchema = useSelector(
    (state) => state.oneUserskillListingReducer?.skillListings?.user_Schema
  )

  const educationRecords = (userSchema?.Profiles?.Consultants_AcademicRecords || [])
    .filter((r) => !r.Deleted)
    .map(mapEducationRecord)

  const education = mode === 'external'
    ? (Array.isArray(rawData?.education) ? rawData.education.map(parseEducationStr) : [])
    : educationRecords

  if (!education.length) return null

  return (
    <section className={styles.card}>
      <SectionHeader title="Education" />
      <div className={styles.educationGrid}>
        {education.map((item, i) => (
          <EduCard key={`${item.title}-${i}`} {...item} />
        ))}
      </div>
    </section>
  )
}

export default EducationSectional
